var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(_vm.$lang.add_content_person)+" ")]),_c('PersonContentFrom',{attrs:{"mode":"add","taskId":_vm.taskId,"isOverlay":_vm.isOverlay,"showDragFile":true},on:{"submit":_vm.save,"closeModal":_vm.closeModal,"responseCode":_vm.getResponseCode}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }